import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';
import { AppRedirectComponent } from './pages/app-redirect/app-redirect.component';
import { StudyDetailsComponent } from './pages/patients/studies/study-details/study-details.component';

const routes: Routes = [
  { path: 'app-redirect', component: AppRedirectComponent },
  { path: 'study/details', component: StudyDetailsComponent, canActivate: [AuthGuard] },
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
